export default {
  "hash": "a3cb392",
  "raw": "v3.12.0",
  "semverString": "3.12.0"
};